module.exports = __webpack_public_path__ + "static/media/recruit_230_default.b4db5fc5.png";